module.exports = __webpack_public_path__ + "static/img/12.b6981f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/12.png
// module id = V8uN
// module chunks = 1